/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Portugal)
export default {
  'fabric.editor.action': 'Item de ação',
  'fabric.editor.action.description': 'Criar e atribuir itens de ação',
  'fabric.editor.addAltText': 'Texto alternativo',
  'fabric.editor.alignImageCenter': 'Alinhar ao centro',
  'fabric.editor.alignImageLeft': 'Alinhar à esquerda',
  'fabric.editor.alignImageRight': 'Alinhar à direita',
  'fabric.editor.altText': 'Todo o texto',
  'fabric.editor.alttext.validation': 'Remova todos os carateres especiais no texto alternativo.',
  'fabric.editor.annotate': 'Anotar',
  'fabric.editor.annotationToolbar': 'Barra de Ferramentas de Anotações',
  'fabric.editor.backLink': 'Retroceder',
  'fabric.editor.blockCardUnavailable': 'A ligação incorporada está no interior do {node} e a sua visualização não pode ser alterada',
  'fabric.editor.blockquote.description': 'Inserir uma cotação ou citação',
  'fabric.editor.bold': 'Negrito',
  'fabric.editor.cancelButton': 'Cancelar',
  'fabric.editor.cardFloatingControls': 'Opções do cartão',
  'fabric.editor.cellBackground': 'Fundo da célula',
  'fabric.editor.cellOptions': 'Opções da célula',
  'fabric.editor.clearAltTextEdit': 'Limpar texto alternativo',
  'fabric.editor.clearCells': '{0, plural, one {Limpar célula} other {Limpar células}}',
  'fabric.editor.clearFormatting': 'Limpar formatação',
  'fabric.editor.clearLink': 'Limpar ligação',
  'fabric.editor.clearLinkText': 'Limpar texto',
  'fabric.editor.closeAltTextEdit': 'Voltar',
  'fabric.editor.closeFindReplaceDialog': 'Fechar',
  'fabric.editor.closeHelpDialog': 'Fechar caixa de diálogo de ajuda',
  'fabric.editor.code': 'Código',
  'fabric.editor.codeblock': 'Fragmento de código',
  'fabric.editor.codeblock.description': 'Apresentar código com realce de sintaxe',
  'fabric.editor.columns': 'Esquemas',
  'fabric.editor.columns.description': 'Estruturar a sua página utilizando secções',
  'fabric.editor.configPanel.cancel': 'Cancelar',
  'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio': 'Não é possível combinar isMultiple com o estilo: rádio',
  'fabric.editor.configPanel.formType.addField': 'Adicionar campos',
  'fabric.editor.configPanel.formType.removeField': 'Remover campo',
  'fabric.editor.configPanel.required': 'Campo obrigatório',
  'fabric.editor.configPanel.submit': 'Enviar',
  'fabric.editor.date': 'Data',
  'fabric.editor.date.description': 'Adicionar uma data utilizando um calendário',
  'fabric.editor.decision': 'Decisão',
  'fabric.editor.decision.description': 'Registar decisões para que estas sejam fáceis de localizar',
  'fabric.editor.decisionPlaceholder': 'Adicionar uma decisão...',
  'fabric.editor.displayInline': 'Visualizar incorporado(a)',
  'fabric.editor.displayLink': 'Mostrar como texto',
  'fabric.editor.displayText': 'Texto a apresentar',
  'fabric.editor.edit': 'Editar',
  'fabric.editor.editAltText': 'Editar texto alternativo',
  'fabric.editor.editLink': 'Editar ligação',
  'fabric.editor.editMode.inviteToEditButton.title': 'Convidar para editar',
  'fabric.editor.editorHelp': 'Ajuda do editor',
  'fabric.editor.emoji': 'Emoji',
  'fabric.editor.emoji.description': 'Utilizar emojis para expressar ideais 🎉 e emoções 😄',
  'fabric.editor.error': 'Erro',
  'fabric.editor.errorPanel': 'Painel de erros',
  'fabric.editor.errorPanel.description': 'Destacar erros num painel colorido',
  'fabric.editor.expand': 'Expandir',
  'fabric.editor.expand.description': 'Introduzir uma expansão',
  'fabric.editor.feedbackDialog': 'Enviar feedback',
  'fabric.editor.feedbackDialog.description': 'Partilhe connosco a sua experiência de utilização do novo editor',
  'fabric.editor.filesAndImages': 'Ficheiros e imagens',
  'fabric.editor.filesAndImages.description': 'Adicionar imagens e outros ficheiros à sua página',
  'fabric.editor.find': 'Localizar',
  'fabric.editor.findNext': 'Localizar seguinte',
  'fabric.editor.findPrevious': 'Localizar anterior',
  'fabric.editor.findReplaceToolbarButton': 'Localizar e substituir',
  'fabric.editor.headerColumn': 'Coluna do cabeçalho',
  'fabric.editor.headerRow': 'Linha do cabeçalho',
  'fabric.editor.heading1': 'Título 1',
  'fabric.editor.heading1Description': 'Utilizar para um cabeçalho de nível superior',
  'fabric.editor.heading2': 'Título 2',
  'fabric.editor.heading2Description': 'Utilize para secções chave',
  'fabric.editor.heading3': 'Título 3',
  'fabric.editor.heading3Description': 'Utilize para títulos de grupos e secções',
  'fabric.editor.heading4': 'Título 4',
  'fabric.editor.heading4Description': 'Utilize para títulos de nível mais profundo',
  'fabric.editor.heading5': 'Título 5',
  'fabric.editor.heading5Description': 'Utilize para agrupar itens de lista',
  'fabric.editor.heading6': 'Título 6',
  'fabric.editor.heading6Description': 'Utilizar para um cabeçalho de nível inferior',
  'fabric.editor.help': 'Ajuda',
  'fabric.editor.help.description': 'Consultar todos os atalhos de teclado e opções de markdown',
  'fabric.editor.helpDialogTips': 'Prima {keyMap} para abrir rapidamente esta caixa de diálogo em qualquer altura',
  'fabric.editor.horizontalRule': 'Divisor',
  'fabric.editor.horizontalRule.description': 'Separar o conteúdo com uma linha horizontal',
  'fabric.editor.image': 'Imagem',
  'fabric.editor.info': 'Informação',
  'fabric.editor.infoPanel': 'Painel de informações',
  'fabric.editor.infoPanel.description': 'Realçar informações num painel colorido',
  'fabric.editor.insertMenu': 'Inserir',
  'fabric.editor.italic': 'Itálico',
  'fabric.editor.keyboardShortcuts': 'Atalhos do teclado',
  'fabric.editor.layoutFixedWidth': 'Voltar ao centro',
  'fabric.editor.layoutFullWidth': 'Passar para a largura completa',
  'fabric.editor.layoutWide': 'Alagar',
  'fabric.editor.leftSidebar': 'Barra lateral esquerda',
  'fabric.editor.link': 'Hiperligação',
  'fabric.editor.link.description': 'Inserir uma ligação',
  'fabric.editor.linkAddress': 'Endereço da ligação',
  'fabric.editor.linkPlaceholder': 'Colar ligação',
  'fabric.editor.lists': 'Listas',
  'fabric.editor.markdown': 'Markdown',
  'fabric.editor.mediaAddLink': 'Adicionar ligação',
  'fabric.editor.mention': 'Mencionar',
  'fabric.editor.mention.description': 'Mencionar alguém enviando-lhes uma notificação',
  'fabric.editor.mergeCells': 'Unir células',
  'fabric.editor.moreFormatting': 'Mais formatação',
  'fabric.editor.normal': 'Texto normal',
  'fabric.editor.note': 'Nota',
  'fabric.editor.notePanel': 'Painel de notas',
  'fabric.editor.notePanel.description': 'Adicionar uma nota num painel colorido',
  'fabric.editor.numberedColumn': 'Coluna numerada',
  'fabric.editor.orderedList': 'Lista numerada',
  'fabric.editor.orderedList.description': 'Criar uma lista ordenada',
  'fabric.editor.other': 'Outros...',
  'fabric.editor.pastePlainText': 'Colar texto simples',
  'fabric.editor.placeholderAltText': 'Descrever esta imagem com texto alternativo',
  'fabric.editor.placeholderText': 'Texto do marcador de posição',
  'fabric.editor.placeholderTextPlaceholder': 'Adicionar texto de marcador de posição',
  'fabric.editor.quickInsert': 'Inserção rápida',
  'fabric.editor.redo': 'Refazer',
  'fabric.editor.remove': 'Remover',
  'fabric.editor.replace': 'Substituir',
  'fabric.editor.replaceAll': 'Substituir tudo',
  'fabric.editor.replaceWith': 'Substituir por',
  'fabric.editor.rightSidebar': 'Barra lateral direita',
  'fabric.editor.saveButton': 'Guardar',
  'fabric.editor.selectLanguage': 'Selecionar idioma',
  'fabric.editor.splitCell': 'Dividir célula',
  'fabric.editor.status': 'Estado',
  'fabric.editor.status.description': 'Adicionar uma etiqueta de estado personalizada',
  'fabric.editor.statusPlaceholder': 'Definir um estado',
  'fabric.editor.strike': 'Rasurado',
  'fabric.editor.subscript': 'inferior à linha',
  'fabric.editor.success': 'Sucesso',
  'fabric.editor.successPanel': 'Painel de sucesso',
  'fabric.editor.successPanel.description': 'Adicionar dicas num painel colorido',
  'fabric.editor.superscript': 'Superior à linha',
  'fabric.editor.supportAltText': 'O texto alternativo é útil para quem utiliza leitores de ecrã devido a limitações visuais.',
  'fabric.editor.table': 'Tabela',
  'fabric.editor.table.description': 'Inserir uma tabela',
  'fabric.editor.tableOptions': 'Opções da tabela',
  'fabric.editor.taskPlaceholder': 'Introduza a ação, utilize "@" para atribuir a um utilizador.',
  'fabric.editor.textColor': 'Cor do texto',
  'fabric.editor.textStyles': 'Estilos de texto',
  'fabric.editor.threeColumns': 'Três colunas',
  'fabric.editor.threeColumnsWithSidebars': 'Três colunas com barras laterais',
  'fabric.editor.twoColumns': 'Duas colunas',
  'fabric.editor.underline': 'Sublinhado',
  'fabric.editor.undo': 'Anular',
  'fabric.editor.unlink': 'Remover ligação',
  'fabric.editor.unorderedList': 'Lista de marcas',
  'fabric.editor.unorderedList.description': 'Criar uma lista não ordenada',
  'fabric.editor.viewMore': 'Ver mais',
  'fabric.editor.visit': 'Abrir ligação numa nova janela',
  'fabric.editor.warning': 'Aviso',
  'fabric.editor.warningPanel': 'Painel de aviso',
  'fabric.editor.warningPanel.description': 'Adicionar uma nota de advertência a um painel colorido',
  'fabric.editor.wrapLeft': 'Alinhar à esquerda',
  'fabric.editor.wrapRight': 'Alinhar à direita',
  'fabric.theme.dark-blue': 'Azul-escuro',
  'fabric.theme.dark-green': 'Verde-escuro',
  'fabric.theme.dark-purple': 'Roxo-escuro',
  'fabric.theme.dark-red': 'Dark red',
  'fabric.theme.dark-teal': 'Verde-azulado-escuro',
  'fabric.theme.dark-yellow': 'Amarelo-escuro',
  'fabric.theme.light-green': 'Verde-claro',
  'fabric.theme.light-purple': 'Roxo-claro',
  'fabric.theme.light-red': 'Vermelho-claro',
  'fabric.theme.light-teal': 'Verde-azulado-claro',
  'fabric.theme.light-yellow': 'Amarelo claro',
  'fabric.theme.white': 'Branco'
};